import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { ShoppingBag, Menu, X, MessageCircle } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { ASSETS } from "@/lib/brand";
import { ContactModal } from "@/components/ContactModal";

const LINKS = [
  { to: "/", label: "Home", end: true },
  { to: "/shop", label: "Shop" },
  { to: "/auctions", label: "Auctions" },
  { to: "/wysiwyg", label: "WYSIWYG" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/wholesale", label: "Wholesale" },
];

export function Nav() {
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />
      <div className="glass border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
            <img src={ASSETS.logoRound} alt="Exotic Reefing Inc" className="w-9 h-9 rounded-full object-cover ring-1 ring-cyan/30 group-hover:ring-cyan/70 transition-all" />
            <span className="text-cyan text-xl font-display tracking-tight hidden sm:inline">Exotic Reefing</span>
          </Link>

          <nav className="hidden md:flex items-center gap-9">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} data-testid={`nav-${l.label.toLowerCase()}`}
                className={({ isActive }) => `mono-label transition-colors ${isActive ? "text-cyan" : "text-white/60 hover:text-white"}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <button onClick={() => setContactOpen(true)} data-testid="nav-contact"
              className="hidden md:inline-flex btn-pill border border-cyan/40 text-cyan hover:bg-cyan/10 transition-colors items-center gap-2 !py-2 !px-4 text-xs">
              <MessageCircle size={15} /> Contact
            </button>
            <Link to="/cart" data-testid="nav-cart" className="relative p-2 text-white/80 hover:text-cyan transition-colors">
              <ShoppingBag size={20} />
              {count > 0 && <span className="absolute -top-0.5 -right-0.5 bg-cyan text-void text-[0.6rem] font-mono w-4 h-4 rounded-full flex items-center justify-center">{count}</span>}
            </Link>
            <button className="md:hidden text-white p-1" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="md:hidden glass border-b border-white/5 px-5 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setOpen(false)}
              className={({ isActive }) => `mono-label ${isActive ? "text-cyan" : "text-white/70"}`}>{l.label}</NavLink>
          ))}
          <button onClick={() => { setOpen(false); setContactOpen(true); }} data-testid="nav-contact-mobile"
            className="mono-label text-cyan text-left flex items-center gap-2"><MessageCircle size={15} /> Contact</button>
        </div>
      )}
    </header>
  );
}
